/* vmx-cookie-fab.js — consent circle (bottom-left) + popover.
   - First visit: the popover auto-opens on landing so the visitor accepts or
     rejects. Granting marketing consent is what unblocks the Meta pixel /
     analytics (Shopify suppresses them until consent is given).
   - On Accept or Reject: the choice is stored, then the circle AND popover
     fade out and are removed. They do not return on later visits.
   - Withdrawal stays possible: the footer "Cookies" link (/pages/cookies) and
     window.vmxCookiePrefs() re-open the popover so a decision can be changed.
   Proxies actions through window.Shopify.customerPrivacy when available;
   falls back to localStorage so the choice persists in dev/preview. */
(function () {
  var STORAGE_KEY = 'vmx_cookie_choice';
  var FAB_HIDDEN_KEY = 'vmx_cookie_fab_dismissed';
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var ui = null; // { fab, pop, setOpen, removeAll } once built

  function makeSvg () {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.8');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');

    var cookie = document.createElementNS(SVG_NS, 'path');
    cookie.setAttribute('d', 'M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5z');
    svg.appendChild(cookie);

    var chips = [[8.5, 10.5], [13, 14.5], [16, 9]];
    chips.forEach(function (c) {
      var dot = document.createElementNS(SVG_NS, 'circle');
      dot.setAttribute('cx', c[0]);
      dot.setAttribute('cy', c[1]);
      dot.setAttribute('r', '0.9');
      dot.setAttribute('fill', 'currentColor');
      svg.appendChild(dot);
    });
    return svg;
  }

  function el (tag, opts) {
    var node = document.createElement(tag);
    if (!opts) return node;
    if (opts.className) node.className = opts.className;
    if (opts.text) node.textContent = opts.text;
    if (opts.attrs) Object.keys(opts.attrs).forEach(function (k) { node.setAttribute(k, opts.attrs[k]); });
    return node;
  }

  /* Has the visitor already made a consent choice?
     Checks our own record first, then Shopify's live consent state. */
  function hasDecided () {
    try { if (localStorage.getItem(STORAGE_KEY)) return true; } catch (e) {}
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && cp.currentVisitorConsent) {
        var c = cp.currentVisitorConsent();
        if (c && (c.marketing === 'yes' || c.marketing === 'no' ||
                  c.analytics === 'yes' || c.analytics === 'no')) return true;
      }
    } catch (e) {}
    return false;
  }

  /* Build the circle + popover once; return controls. */
  function buildUI () {
    if (ui) return ui;

    var fab = el('button', {
      className: 'vmx-cookie-fab',
      attrs: { id: 'vmx-cookie-fab', type: 'button', 'aria-label': 'Cookie preferences', 'aria-expanded': 'false' }
    });
    fab.appendChild(makeSvg());

    var xBtn = el('span', {
      className: 'vmx-cookie-fab__x',
      text: '×',
      attrs: { role: 'button', tabindex: '0', 'aria-label': 'Hide cookie button' }
    });
    fab.appendChild(xBtn);

    var pop = el('div', {
      className: 'vmx-cookie-pop',
      attrs: { id: 'vmx-cookie-pop', role: 'dialog', 'aria-label': 'Cookie preferences', 'data-open': 'false' }
    });
    pop.appendChild(el('p', { className: 'vmx-cookie-pop__title', text: 'A quiet note —' }));

    var body = el('p', { className: 'vmx-cookie-pop__body' });
    body.appendChild(document.createTextNode('We use cookies for analytics and to remember your basket. '));
    var link = el('a', { text: 'Privacy policy', attrs: { href: '/policies/privacy-policy' } });
    body.appendChild(link);
    body.appendChild(document.createTextNode('.'));
    pop.appendChild(body);

    var btnRow = el('div', { className: 'vmx-cookie-pop__btns' });
    var actions = [
      { key: 'accept', text: 'Accept', cls: 'vmx-cookie-pop__btn vmx-cookie-pop__btn--accept' },
      { key: 'decline', text: 'Decline', cls: 'vmx-cookie-pop__btn vmx-cookie-pop__btn--decline' },
      { key: 'prefs', text: 'Manage', cls: 'vmx-cookie-pop__btn vmx-cookie-pop__btn--prefs' }
    ];
    actions.forEach(function (a) {
      var b = el('button', { className: a.cls, text: a.text, attrs: { type: 'button', 'data-vmx-cookie': a.key } });
      btnRow.appendChild(b);
    });
    pop.appendChild(btnRow);

    document.body.appendChild(fab);
    document.body.appendChild(pop);

    function setOpen (open) {
      pop.setAttribute('data-open', open ? 'true' : 'false');
      fab.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    /* Fade the circle + popover out, then remove from the DOM. */
    function removeAll () {
      pop.setAttribute('data-open', 'false');
      fab.style.transition = 'opacity 260ms ease, transform 260ms cubic-bezier(0.23,1,0.32,1)';
      fab.style.opacity = '0';
      fab.style.transform = 'translateY(8px) scale(0.9)';
      window.setTimeout(function () {
        try { fab.remove(); } catch (e) {}
        try { pop.remove(); } catch (e) {}
        if (ui && ui.fab === fab) ui = null;
      }, 300);
    }

    fab.addEventListener('click', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('vmx-cookie-fab__x')) return;
      setOpen(pop.getAttribute('data-open') !== 'true');
    });

    xBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      try { localStorage.setItem(FAB_HIDDEN_KEY, '1'); } catch (err) {}
      removeAll();
    });
    xBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); xBtn.click(); }
    });

    document.addEventListener('click', function (e) {
      if (!pop.contains(e.target) && !fab.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    pop.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vmx-cookie]');
      if (!btn) return;
      var action = btn.getAttribute('data-vmx-cookie');
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      // "Manage" opens Shopify's preference centre — not a final decision, so
      // don't record it or dismiss the circle.
      if (action === 'prefs') {
        try { if (cp && cp.showPreferences) cp.showPreferences(); } catch (err) {}
        return;
      }
      var grant = action === 'accept';
      try {
        if (cp && cp.setTrackingConsent) {
          cp.setTrackingConsent({ analytics: grant, marketing: grant, preferences: grant, sale_of_data: grant }, function () {});
        }
      } catch (err) { /* no-op */ }
      try { localStorage.setItem(STORAGE_KEY, action); } catch (err) {}
      // Decision made: close + remove the circle and popover entirely.
      removeAll();
    });

    ui = { fab: fab, pop: pop, setOpen: setOpen, removeAll: removeAll };
    return ui;
  }

  /* Public opener — used by the footer "Cookies" link so consent can be
     changed after the circle is gone (GDPR withdrawal must stay easy). */
  function openPrefs () {
    var u = buildUI();
    u.setOpen(true);
    return false;
  }

  /* Let the footer "Cookies" link (and any [data-vmx-cookie-prefs]) re-open
     the popover instead of (or as well as) navigating away. */
  function bindReopeners () {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('a[href="/pages/cookies"], a[href$="/pages/cookies"], [data-vmx-cookie-prefs]');
      if (!t) return;
      e.preventDefault();
      openPrefs();
    });
  }

  function init () {
    window.vmxCookiePrefs = openPrefs;
    bindReopeners();

    var fabHidden = false;
    try { fabHidden = localStorage.getItem(FAB_HIDDEN_KEY) === '1'; } catch (e) {}
    // Already decided, or explicitly hidden → don't surface the circle.
    if (fabHidden || hasDecided()) return;

    var u = buildUI();
    // First visit: auto-open so the visitor accepts or rejects on landing.
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.setTimeout(function () {
      if (ui && !hasDecided()) u.setOpen(true);
    }, reduce ? 0 : 650);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
